import { Injectable } from '@angular/core';
import { getApp } from '@angular/fire/app';
import { deleteObject, getDownloadURL, getStorage, ref as storageRef, StorageReference, uploadBytes } from '@angular/fire/storage';
import { GCPImage } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {
    constructor() {}

    private getFirebaseStorage() {
        try {
            return getStorage(getApp());
        } catch (error) {
            console.error('Firebase Storage initialization error:', error);
            throw new Error('Firebase Storage is not initialized. Please ensure Firebase is properly configured.');
        }
    }

    async uploadImage(file: File, imageCategoryPath: string) {
        try {
            const firebaseStorage = this.getFirebaseStorage();
            const storageReference = storageRef(firebaseStorage, `${imageCategoryPath}/${file.name}_${Date.now()}`);
            const { metadata, ref } = await uploadBytes(storageReference, file);
            const downloadUrl = await getDownloadURL(ref as StorageReference);
            return {
                downloadUrl,
                bucket: metadata.bucket,
                contentType: metadata.contentType,
                fullPath: metadata.fullPath,
                name: metadata.name,
                size: metadata.size,
                timeCreated: metadata.timeCreated
            } as GCPImage;

        } catch(err: unknown) {
            console.error('Error uploading image:', err);
            return null;
        }
    }

    async deleteImage(file: GCPImage) {
        try {
            const firebaseStorage = this.getFirebaseStorage();
            const deleteObjRef = storageRef(firebaseStorage, file.fullPath);
            await deleteObject(deleteObjRef);
            return true;

        } catch(err: unknown) {
            console.error('Error deleting image:', err);
            return false;
        }
    }
}